import { parseHash } from '../components/navigation.js';

export type SourceKind = 'online' | 'torrent';

/**
 * Адрес шага карточки — с классом источников, взятым ИЗ ТЕКУЩЕГО АДРЕСА.
 *
 * Читать класс из состояния страницы нельзя, и это не вкусовщина. Обработчики
 * карточки — обычные функции, создаваемые заново на каждый рендер, и они живут
 * дольше своего рендера: выбор источника уходит в сеть за озвучками и
 * возвращается уже в другую эпоху. Класс, захваченный при создании, к этому
 * моменту устарел — так «Смотреть онлайн» и уводило на торренты: переход к
 * списку серий подставлял класс из того рендера, где онлайн ещё не был выбран.
 *
 * Адрес такого прошлого не помнит: в нём всегда то, где зритель находится
 * сейчас. Явно переданный класс важнее — им пользуется сам выбор способа
 * («смотреть онлайн», «торренты»), где адрес ещё не успел смениться.
 */
export function titleStepHash(
  currentHash: string,
  contentId: string,
  next: 'overview' | 'sources' | 'episodes',
  kind?: SourceKind,
): string {
  const base = `#/title/${encodeURIComponent(contentId)}`;
  // У описания шагов нет, и класс ему не нужен: это самый верх карточки.
  if (next === 'overview') return base;
  const current = parseHash(currentHash);
  // Класс из адреса берём только если адрес про ЭТОТ тайтл: на чужом (переход
  // по ссылке, незакрытая вкладка) он значит не то, чем кажется.
  const fromUrl = current.name === 'title' && current.contentId === contentId ? current.kind : null;
  return `${base}/${next}/${kind ?? fromUrl ?? 'torrent'}`;
}
